<template>
  <b-modal v-model="show" hide-footer hide-header centered>
    <b-overlay :show="isLoading">
      <h3 class="mt-1 mb-2">
        <strong
          >{{ usecase === "add" ? "Додати" : "Редагувати" }} тему
          звернення</strong
        >
      </h3>
      <div class="form-input mb-2">
        <label>Назва теми</label>
        <b-form-input v-model="topic.name" />
      </div>
      <div class="form-input mb-2">
        <label>Відділ</label>
        <b-form-select v-model="topic.department_id" class="mr-1">
          <b-form-select-option
            v-for="d in departments"
            :value="d.id"
            :key="d.id"
          >
            {{ d.name }}
          </b-form-select-option>
        </b-form-select>
      </div>
      <div class="cta">
        <b-button class="w-100 mb-1" @click="saveChanges" variant="success">
          Зберегти
        </b-button>
        <b-button @click="cancel" variant="outline-danger w-100">
          Скасувати
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  props: {
    departments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      isLoading: false,
      usecase: "add",
      topic: {
        name: "",
        department_id: null,
        uid: null,
      },
    };
  },
  methods: {
    cancel() {
      this.show = false;
      this.topic = {
        name: "",
        department_id: null,
        uid: null,
      };
    },
    validate() {
      let valid = true;
      if (this.topic.name.length < 8 || this.topic.name.length > 100) {
        this.$toast.error("Назва теми повинна містити від 8 до 100 символів");
        valid = false;
      }
      if (this.topic.department_id === null) {
        this.$toast.error("Виберіть відділ");
        valid = false;
      }
      return valid;
    },
    async addTopic() {
      this.isLoading = true;
      const topic = {
        name: this.topic.name,
        department_id: this.topic.department_id,
      };
      try {
        var result = await this.$api.post("/admin/topics/create", topic);
        if (result.data.success === true) {
          this.$emit("update");
          this.$toast.success("Тему успішно додано");
          this.cancel();
        }
      } catch (e) {
        this.$toast.error("Помилка при додаванні теми");
      }
      this.isLoading = false;
    },
    async editTopic() {
      this.isLoading = true;
      const topic = {
        uid: this.topic.uid,
        name: this.topic.name,
        department_id: this.topic.department_id,
      };
      try {
        await this.$api.post("/admin/topics/update", topic);
        this.$emit("update");
        this.$toast.success("Тему успішно відредаговано");
        this.cancel();
      } catch (e) {
        this.$toast.error("Помилка при редагуванні теми");
      }
      this.isLoading = false;
    },
    saveChanges() {
      let valid = this.validate();
      if (valid === false) {
        return;
      }
      if (this.usecase === "add") {
        this.addTopic();
      } else {
        this.editTopic();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
